/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BasicAlertComponent } from './basic-alert.component';

@Component({
  selector: 'spin-alert',
  templateUrl: './spin-alert.component.html',
  styleUrls: ['./spin-alert.component.less'],
  standalone: false,
})
export class SpinAlertComponent extends BasicAlertComponent {
  @Input() spinState = true;

  constructor(public override activeModal: NgbActiveModal) {
    super(activeModal);
  }
}
